function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    instagram\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,5.39c4.59,0,5.13,0,7,.1a9.81,9.81,0,0,1,3.19.59,5.31,5.31,0,0,1,2,1.29,5.19,5.19,0,0,1,1.29,2,9.31,9.31,0,0,1,.59,3.2c.08,1.81.1,2.35.1,6.94s0,5.14-.1,7a9.29,9.29,0,0,1-.59,3.19,5.69,5.69,0,0,1-3.26,3.26,9.29,9.29,0,0,1-3.19.59c-1.82.09-2.36.1-6.95.1s-5.13,0-6.95-.1a9.29,9.29,0,0,1-3.19-.59A5.69,5.69,0,0,1,6.6,29.62,9.29,9.29,0,0,1,6,26.43c-.08-1.81-.1-2.36-.1-6.95s0-5.13.1-6.94a9.31,9.31,0,0,1,.59-3.2,5.19,5.19,0,0,1,1.29-2,5.31,5.31,0,0,1,2-1.29,9.81,9.81,0,0,1,3.19-.59c1.82-.08,2.36-.1,7-.1m0-3.1c-4.67,0-5.25,0-7.09.11a12.36,12.36,0,0,0-4.17.8,8.18,8.18,0,0,0-3,2,8.34,8.34,0,0,0-2,3,13,13,0,0,0-.8,4.18c-.08,1.83-.1,2.41-.1,7.08s0,5.26.1,7.09a12.88,12.88,0,0,0,.8,4.17,8.81,8.81,0,0,0,5,5,12.88,12.88,0,0,0,4.17.8c1.84.08,2.42.1,7.09.1s5.25,0,7.09-.1a12.88,12.88,0,0,0,4.17-.8,8.81,8.81,0,0,0,5-5,12.88,12.88,0,0,0,.8-4.17c.08-1.83.1-2.42.1-7.09s0-5.25-.1-7.08a13,13,0,0,0-.8-4.18,8.34,8.34,0,0,0-2-3,8.18,8.18,0,0,0-3-2,12.36,12.36,0,0,0-4.17-.8c-1.84-.09-2.42-.11-7.09-.11Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20,10.66a8.83,8.83,0,1,0,8.83,8.82A8.83,8.83,0,0,0,20,10.66Zm0,14.55a5.73,5.73,0,1,1,5.73-5.73A5.73,5.73,0,0,1,20,25.21Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.18,
  cy: 10.31,
  r: 2.06,
  fill: "#231f20"
});

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgInstagram;